var map = {
	"./2005.jpg": 70,
	"./2005_Deutschland.jpeg": 546,
	"./2005_UK.jpeg": 7339,
	"./2005_USA.jpeg": 3404,
	"./2005_USA.png": 397,
	"./2005_USA3.jpeg": 819,
	"./2005_USA4.jpeg": 6508,
	"./2005_USA5.jpeg": 7997,
	"./2005_USA6.jpeg": 8233,
	"./2005_USA7.jpeg": 8644,
	"./2006.jpg": 9457,
	"./2006_Kanada.jpeg": 2717,
	"./2006_UK.jpeg": 2158,
	"./2006_USA.jpeg": 5265,
	"./2006_USA10.jpeg": 1934,
	"./2006_USA11.jpeg": 2075,
	"./2006_USA12.jpeg": 1411,
	"./2006_USA2.jpeg": 3571,
	"./2006_USA3.jpeg": 7378,
	"./2006_USA5.jpeg": 129,
	"./2006_USA8.jpeg": 4719,
	"./2006_USA9.jpeg": 6066,
	"./2006_USA_2.jpeg": 4099,
	"./2007.jpg": 8091,
	"./2007_Australia.jpeg": 7168,
	"./2007_Japan.jpeg": 5906,
	"./2007_Kolumbien.jpeg": 3217,
	"./2007_NYE USA.jpeg": 6173,
	"./2007_New York.jpeg": 5091,
	"./2007_South Africa.jpeg": 8571,
	"./2007_USA.jpeg": 3890,
	"./2007_USA2.jpeg": 2934,
	"./2008.jpg": 6834,
	"./2008_Australien.jpeg": 8921,
	"./2008_Le Refuge des Fondues, Paris.jpeg": 2018,
	"./2011.jpg": 7583,
	"./2011_Frankreich.jpeg": 3167,
	"./2015.jpg": 4242,
	"./2015_Brasil.jpeg": 7796,
	"./2017.jpg": 6098,
	"./2017_Brasil.jpeg": 6448,
	"./2017_Frankreich.jpeg": 4041,
	"./2018.jpg": 1836,
	"./2018_Brasil.jpeg": 9571,
	"./2021.jpg": 7156,
	"./2021_Brasil.png": 2895,
	"./2021_Brasilien.jpeg": 6655,
	"./2021_Frankreich.jpeg": 9195,
	"./2021_Frankreich2.jpeg": 3827,
	"./2022.jpg": 7086,
	"./2022_Angola.jpeg": 7857,
	"./2022_Brasil...png": 1058,
	"./2022_Brasil..png": 4514,
	"./2022_Brasil.png": 4381,
	"./2022_Fiji.jpeg": 9871,
	"./2022_Frankreich.jpeg": 8525,
	"./2022_Frankreich.png": 5367,
	"./2022_Frankreich3.jpeg": 2213,
	"./2022_HongKong.png": 296,
	"./2022_Kanada.jpeg": 2415,
	"./2022_Kanada.png": 8907,
	"./2022_Thailand.jpeg": 5785,
	"./2022_UK.png": 3602,
	"./2022_USA3.jpeg": 1785,
	"./2022_Vietnam.jpeg": 2017,
	"./2022_Vietnam2.jpeg": 1124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6201;